var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.noticeStore.noticeItems.length > 0)?_c('grid',{staticStyle:{"max-width":"100%"},attrs:{"data-items":_vm.noticeStore.noticeItems,"columns":[
      { field: 'name', title: _vm.$t('Megnevezes'), width: 200 },
      {
        field: 'quantity',
        title: _vm.$t('Mennyiseg'),
        cell: 'quantityTemplate',
        width: 170,
      },
      {
        field: 'currUnitPrice',
        title: _vm.$t('Notice_EgysegarDev'),
        cell: 'currUnitPriceTemplate',
        width: 170,
        headerClassName: 'right_text'
      },
      {
        field: 'currBrutto',
        title: _vm.$t('BruttoDev'),
        cell: 'currBruttoTemplate',
        width: 170,
        headerClassName: 'right_text'
      },
      {
        field: 'currNetto',
        title: _vm.$t('NettoDev'),
        cell: 'currNettoTemplate',
        headerClassName: 'right_text'
      },
      {
        field: 'currVat',
        title: _vm.$t('AFADev'),
        cell: 'currVatTemplate',
        headerClassName: 'right_text'
      },
      {
        field: 'unitPrice',
        title: _vm.$t('Egysegar'),
        cell: 'unitPriceTemplate',
        headerClassName: 'right_text'
      },
      {
        field: 'brutto',
        title: _vm.$t('Brutto'),
        cell: 'bruttoTemplate',
        headerClassName: 'right_text'
      },
      {
        field: 'netto',
        title: _vm.$t('Netto'),
        cell: 'nettoTemplate',
        headerClassName: 'right_text'
      },
      {
        field: 'vat',
        title: _vm.$t('AFA'),
        cell: 'vatTemplate',
        headerClassName: 'right_text'
      },
      { cell: 'commandTemplate', width: '55px' } ]},scopedSlots:_vm._u([{key:"quantityTemplate",fn:function(ref){
    var props = ref.props;
return [_c('td',{class:props.className},[_c('money-input',{staticStyle:{"margin-top":"6px"},attrs:{"currency":props.dataItem.displayedUnit,"disabled":_vm.disabled},on:{"input":function($event){return _vm.quantityChanged(props.dataItem)}},model:{value:(props.dataItem.quantity),callback:function ($$v) {_vm.$set(props.dataItem, "quantity", _vm._n($$v))},expression:"props.dataItem.quantity"}})],1)]}},{key:"currUnitPriceTemplate",fn:function(ref){
    var props = ref.props;
return [_c('td',{class:props.className},[_c('money-input',{staticStyle:{"margin-top":"6px"},attrs:{"currency":_vm.$props.invCurrency,"disabled":_vm.disabled},on:{"input":function($event){return _vm.unitPriceChanged(props.dataItem)}},model:{value:(props.dataItem.currUnitPrice),callback:function ($$v) {_vm.$set(props.dataItem, "currUnitPrice", _vm._n($$v))},expression:"props.dataItem.currUnitPrice"}})],1)]}},{key:"currBruttoTemplate",fn:function(ref){
    var props = ref.props;
return [_c('td',{class:props.className},[_c('money-input',{staticStyle:{"margin-top":"6px"},attrs:{"currency":_vm.$props.invCurrency,"disabled":_vm.disabled},on:{"input":function($event){return _vm.bruttoChanged(props.dataItem)}},model:{value:(props.dataItem.currBrutto),callback:function ($$v) {_vm.$set(props.dataItem, "currBrutto", _vm._n($$v))},expression:"props.dataItem.currBrutto"}})],1)]}},{key:"currNettoTemplate",fn:function(ref){
    var props = ref.props;
return [_c('td',{class:props.className},[_c('money-display',{staticStyle:{"margin-top":"6px"},attrs:{"value":props.dataItem.currNetto,"currency":_vm.$props.invCurrency,"disabled":_vm.disabled}})],1)]}},{key:"currVatTemplate",fn:function(ref){
    var props = ref.props;
return [_c('td',{class:props.className},[_c('money-display',{staticStyle:{"margin-top":"6px"},attrs:{"value":props.dataItem.currVat,"currency":_vm.$props.invCurrency,"disabled":_vm.disabled}})],1)]}},{key:"unitPriceTemplate",fn:function(ref){
    var props = ref.props;
return [_c('td',{class:props.className},[_c('money-display',{staticStyle:{"margin-top":"6px"},attrs:{"value":props.dataItem.unitPrice,"currency":_vm.$props.currency,"disabled":_vm.disabled}})],1)]}},{key:"bruttoTemplate",fn:function(ref){
    var props = ref.props;
return [_c('td',{class:props.className},[_c('money-display',{staticStyle:{"margin-top":"6px"},attrs:{"value":props.dataItem.brutto,"currency":_vm.$props.currency,"disabled":_vm.disabled}})],1)]}},{key:"nettoTemplate",fn:function(ref){
    var props = ref.props;
return [_c('td',{class:props.className},[_c('money-display',{staticStyle:{"margin-top":"6px"},attrs:{"value":props.dataItem.netto,"currency":_vm.$props.currency,"disabled":_vm.disabled}})],1)]}},{key:"vatTemplate",fn:function(ref){
    var props = ref.props;
return [_c('td',{class:props.className},[_c('money-display',{staticStyle:{"margin-top":"6px"},attrs:{"value":props.dataItem.vat,"currency":_vm.$props.currency,"disabled":_vm.disabled}})],1)]}},{key:"commandTemplate",fn:function(ref){
    var props = ref.props;
return [_c('td',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
    var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","outlined":"","color":"primary"},on:{"click":function($event){return _vm.deleteItem(props.dataItem)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"x-small":""}},[_vm._v("fa-trash-o")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('Torles')))])])],1)]}}],null,false,2067793995)}):_c('label',{staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.$t('Notice_NincsHozzarendeltTetel')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }